import type { IconData } from '@stacksjs/iconify-core'

export const earth1Flat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M.5 24C.5 36.979 11.021 47.5 24 47.5S47.5 36.979 47.5 24S36.979.5 24 .5S.5 11.021.5 24\"/><path fill=\"#2859c5\" d=\"M42.192 9.123c-4.348.857-10.695 2.663-13.899 3.574h-.002l-.968.275c-1.577.446-3.04 1.384-3.617 2.911a10 10 0 0 0-.493 1.804c-.483 2.712 1.735 4.871 4.411 5.581l2.412.64a3.02 3.02 0 0 1 1.924 1.601c1.136 2.323 6.275 9.838 10.024 13.62A23.4 23.4 0 0 0 47.5 24a23.4 23.4 0 0 0-5.308-14.877M15.135 45.771c1.393-3.345 2.866-8.797 3.22-10.198c.223-.878.17-1.798-.198-2.627c-.81-1.816-2.64-5.046-5.796-6.204a3.7 3.7 0 0 0-.833-.19c-1.132-.137-7.083-.473-10.925-.338c.829 8.88 6.598 16.324 14.532 19.557\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default earth1Flat
